import { ImageSize, PosterSize } from '#enums/imageSizes.ts';
import { SectionType } from '#enums/mediaTypes.ts';
import { buildImagePath } from '#helpers/buildImagePath.ts';
import { type Config } from '#types.ts';
import { type TileItem } from '../../Tile/types.ts';
import { type MovieCollectionData } from '../types.ts';

export const formatCollectionCarouselItems = (data: MovieCollectionData | null | undefined, { images }: Config) =>
  data
    ? (data.movie.belongsToCollection?.parts ?? []).reduce((acc: TileItem[], part) => {
        if (!part) {
          return acc;
        }

        acc.push({
          id: part.id,
          src: buildImagePath(part.posterPath, ImageSize.Poster, PosterSize.SM, images),
          status: part.status,
          title: part.title,
          type: SectionType.Movie,
          voteAverage: part.voteAverage,
        });

        return acc;
      }, [])
    : [];
